import { updateUserStore, type UserStore } from "../../stores/user";
import { updateAddressesStore, type AddressesStore } from "../../stores/addresses";
import { campaignUserStore, type CampaignUserStore } from "../../stores/campaignUser";

// Presets:
import virginUser from "./presets/virginUser";
import existingUser from "./presets/existingUser";
import postalSuccess from "./presets/postalSuccess";
import manualSuccess from "./presets/manualSuccess";
import digitalSuccess from "./presets/digitalSuccess";
import onDemandSuccess from "./presets/onDemandSuccess";
import invalidAddress from "./presets/invalidAddress";
import userInvalidCharacters from "./presets/userInvalidCharacters";
import userInvalidFields from "./presets/userInvalidFields";
import userValidations from "./presets/userValidations";

// Keep adding more types as needed for the scenarios
export type Scenario = {
  userStore?: Partial<UserStore>;
  addressesStore?: Partial<AddressesStore>;
  campaignUserStore?: CampaignUserStore;
};

const Presets: { [key: string]: Scenario } = {
  virginUser,
  existingUser,
  postalSuccess,
  manualSuccess,
  digitalSuccess,
  onDemandSuccess,
  invalidAddress,
  userInvalidCharacters,
  userInvalidFields,
  userValidations
};

export const setScenario = (scenario: Scenario) => {
  scenario.userStore && updateUserStore(scenario.userStore);
  scenario.addressesStore && updateAddressesStore(scenario.addressesStore);
  scenario.campaignUserStore && campaignUserStore.set(scenario.campaignUserStore);
};

export const setPresetScenario = (preset: string) => {
  Presets[preset]
    ? setScenario(Presets[preset])
    : console.error(`Preset ${preset} not found`);
};
